


































































import { Component, Vue } from "vue-property-decorator";
import AdminsApi from "@/services/AdminsApi";
import UsersApi from "@/services/UsersApi";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import { EmailWithConfirm } from "@/api/lab-base-api-client";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class ResendForm extends Vue {
  // 入力フォーム
  private form: EmailWithConfirm = {
    email: "",
    confirmEmail: "",
  };

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // 送信が押されたとき
  private async submit() {
    try {
      // routeがMPreRegisterResendの場合
      if (this.$route.name === "MPreRegisterResend") {
        // adminSendTokenを実行
        await this.adminSendToken();
      } else {
        // そうでない場合はadminSendTokenを実行
        await this.userSendToken();
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  private async userSendToken() {
    // formに入力されたアドレスにtoken発行
    await UsersApi.instance.sendUserRegisterToken(this.form);
    // UPreRegisterResendCompに進む
    this.$router.push({ name: "UPreRegisterResendComp" });
  }

  private async adminSendToken() {
    // formに入力されたアドレスにtoken発行
    await AdminsApi.instance.sendAdminRegisterToken(this.form);
    // MPreRegisterResendCompに進む
    this.$router.push({ name: "MPreRegisterResendComp" });
  }
}
